import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Info2Icon } from "@/shared/icons";
import { Tooltip } from "@/shared/ui";
import BusinessTooltipContent from "@/domains/business/components/BusinessTooltipContent";

type Props = {
  text: string;
  currentLevel: number;
  maxLevel: number;
  icon: ReactNode;
  tooltipDescription: string;
};

export default function ImprovementsListItem({
  text,
  currentLevel,
  maxLevel,
  icon,
  tooltipDescription,
}: Props) {
  const { t } = useTranslation("business");

  const tooltipContent = <BusinessTooltipContent description={tooltipDescription} />;

  return (
    <div className="flex justify-between items-center py-3 px-3.5 bg-dark-800/50 rounded-xl">
      <div className="flex items-center gap-2.5">
        {icon}
        <p className="text-16 font-medium">{text}</p>
      </div>
      <div className="flex items-center gap-2.5">
        <p className="flex items-center gap-0.5 py-1 px-1.5 text-11 font-bold uppercase bg-accent-solid/20 rounded-[0.3125rem]">
          <span className="text-accent-solid">
            {currentLevel === maxLevel ? "MAX" : currentLevel}
          </span>
          {t("business.improvements.lvl")}.
        </p>
        <Tooltip content={tooltipContent} tooltipClassName="bottom-1/2 right-6 translate-y-1/2">
          <Info2Icon className="size-4 opacity-50 transition-all duration-200 hover:opacity-100" />
        </Tooltip>
      </div>
    </div>
  );
}
